import React from 'react';
import { RestrictionsSelector } from 'subdomains/cpo/screens/GroupsAndPolicies/Tariff/Restrictions/RestrictionsSelector';
import { EnergyRestriction } from 'subdomains/cpo/screens/GroupsAndPolicies/Tariff/Restrictions/EnergyRestriction';
import { FormikState } from 'formik';
import { TariffComponent } from 'subdomains/cpo/types/charging-policy';
import { DateRestriction } from 'subdomains/cpo/screens/GroupsAndPolicies/Tariff/Restrictions/DateRestriction';
import { TimeOfDayRestriction } from 'subdomains/cpo/screens/GroupsAndPolicies/Tariff/Restrictions/TimeOfDayRestriction';
import { DurationRestriction } from 'subdomains/cpo/screens/GroupsAndPolicies/Tariff/Restrictions/DurationRestriction';
import { DaysOfWeekRestriction } from 'subdomains/cpo/screens/GroupsAndPolicies/Tariff/Restrictions/DayOfWeekRestriction';
import { buildFormPath } from 'subdomains/cpo/utils/formpath';

type Props = {
  values: FormikState<TariffComponent['restrictions']>['values'];
  basePath: string;
};

export const Restrictions = (props: Props) => {
  return (
    <>
      <RestrictionsSelector basePath={props.basePath} />
      {props.values?.energy?.enabled && (
        <EnergyRestriction basePath={buildFormPath('energy', props.basePath)} />
      )}
      {props.values?.duration?.enabled && (
        <DurationRestriction
          basePath={buildFormPath('duration', props.basePath)}
        />
      )}
      {props.values?.daysOfWeek?.enabled && (
        <DaysOfWeekRestriction
          basePath={buildFormPath('daysOfWeek', props.basePath)}
        />
      )}
      {props.values?.timeOfDay?.enabled && (
        <TimeOfDayRestriction
          basePath={buildFormPath('timeOfDay', props.basePath)}
        />
      )}
      {props.values?.date?.enabled && (
        <DateRestriction basePath={buildFormPath('date', props.basePath)} />
      )}
    </>
  );
};
